"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _CardLine = _interopRequireDefault(require("../CardLine"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var JobofferCard = function JobofferCard(_ref) {
  var diagnosticFit = _ref.diagnosticFit,
      companyName = _ref.companyName,
      cardLines = _ref.cardLines,
      status = _ref.status,
      index = _ref.index,
      distance = _ref.distance,
      animation = _ref.animation,
      discriminator = _ref.discriminator;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      changeStyle = _useState2[0],
      setChangeStyle = _useState2[1];

  var listenToScroll = (0, _react.useCallback)(function () {
    var dc = function dc(id) {
      return document ? document.getElementById(id) : false;
    };

    var node = {
      header: dc('header' + index),
      staticMapTop: dc('staticMapTop' + index),
      monetization: dc('monetizationTypo' + index),
      description: dc('description' + index),
      school: dc('school' + index),
      title: dc('title' + index)
    };

    if (document && node['header']) {
      var topOffset = node['staticMapTop'].offsetHeight + 10;
      var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      var scrollPos = winScroll - topOffset;

      if (winScroll > topOffset) {
        node['header'].style.top = scrollPos + 'px';

        if (!changeStyle) {
          if (node['monetization']) node['monetization'].style.display = 'none';
          if (node['school']) node['school'].style.display = 'none';
          node['title'].style.fontSize = '20px';
          node['title'].style.lineHeight = '26px';
          setChangeStyle(true);
        }
      } else {
        if (changeStyle) {
          node['header'].style.top = '0px';
          if (node['monetization']) node['monetization'].style.display = 'block';
          if (node['school']) node['school'].style.display = 'block';
          node['title'].style.fontSize = '28px';
          node['title'].style.lineHeight = '33px';
          setChangeStyle(false);
        }
      }
    }
  }, [index, changeStyle]);
  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', listenToScroll);
    return function () {
      return window.removeEventListener('scroll', listenToScroll);
    };
  }, [listenToScroll]); // End of Title Animation

  switch (animation) {
    case 'like':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});

    case 'dislike':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});

    case 'loading':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});

    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "".concat(_styleModule.default.bordered, " ").concat(_styleModule.default[status]),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          container: true,
          direction: "row",
          justifyContent: "center",
          alignItems: "center",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
            item: true,
            xs: 10,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
              component: "h3",
              className: _styleModule.default.companyName,
              children: companyName
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
              container: true,
              direction: "row",
              justifyContent: "center",
              alignItems: "center",
              children: cardLines.map(function (cardLine) {
                var cli = cardLine.icon;

                var diagnosticIfExist = function diagnosticIfExist(cli) {
                  return cli && cli === 'favorite' ? diagnosticFit : {};
                };

                var distanceIfExist = function distanceIfExist(cli) {
                  return cli && cli === 'location' && distance !== '' && distance !== undefined ? " (".concat(distance, " km)") : '';
                };

                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardLine.default, (0, _extends2.default)({
                  index: index,
                  status: status,
                  discriminator: discriminator,
                  distance: distanceIfExist(cli),
                  diagnostic: diagnosticIfExist(cli),
                  className: "".concat(_styleModule.default[status])
                }, cardLine), 'cl' + index + '_' + cli);
              })
            })]
          })
        })
      });
  }
};

var _default = /*#__PURE__*/(0, _react.memo)(JobofferCard);

exports.default = _default;